import View from '@/base/tables/view';

class UserView extends View {

    static table = 'user';

}

export default UserView;
